import {Collapse, Input} from "antd";
import parse from "html-react-parser";
import React, {Component, ReactNode} from "react";
import searchActive from "../../assets/images/search-blue.svg";
import searchPassive from "../../assets/images/search-gray.svg";
import FirebaseKey from "../../components/FirebaseKey/FirebaseKey";
import FirebaseService from "../../core/services/firebaseService/firebase.service";
import {history} from "../../core/utilities/history";
import {router} from "../../core/utilities/router";
import "./FaqPage.scss";

const {Panel} = Collapse;

interface IProps {
}

interface QNA {
  question: string;
  answer: string;
}

interface IState {
  searchKey: string;
  qnas: QNA[];
}

class FaqPage extends Component<IProps> {
  state: IState = {
    searchKey: '',
    qnas: [],
  }

  componentDidMount() {
    const questions: string[] = FirebaseService.getQuestions();
    const answers: string[] = FirebaseService.getAnswers();
    if (questions.length !== answers.length) {
      return;
    }
    let qnas: QNA[] = [];
    questions.forEach((question, index) => {
      qnas.push({
        question: question,
        answer: answers[index],
      })
    });
    this.setState({qnas});
  }

  private handleClickContactUs = (): void => {
    history.push(router.CONTACT);
  }

  private renderSearch(): ReactNode {
    return (
      <div className="search-wrapper">
        <Input
          className="search"
          placeholder={FirebaseService.getValue(FirebaseService.faq_search)}
          suffix={<img src={this.state.searchKey ? searchActive : searchPassive} alt="search"/>}
          value={this.state.searchKey}
          onChange={e => this.setState({searchKey: e.target.value})}
        />
      </div>
    );
  }

  private renderQNAs(): ReactNode {
    const query = this.state.searchKey.toLocaleLowerCase('tr');
    const qnas = this.state.qnas.filter(qna => {
      return (
        qna.question.toLocaleLowerCase('tr').includes(query) ||
        qna.answer.toLocaleLowerCase('tr').includes(query)
      );
    })
    return (
      <Collapse
        className="questions"
        accordion
        ghost
        expandIconPosition="right"
      >
        {qnas.map(qna => {
          return (
            <Panel header={parse(qna.question)} key={qna.question}>
              {parse(qna.answer)}
              {this.renderQuestionSupplementary()}
            </Panel>
          );
        })}
        {
          qnas.length === 0
            ? this.renderEmptyList()
            : this.renderLink()
        }
      </Collapse>
    );
  }

  private renderQuestionSupplementary(): ReactNode {
    return (
      <div className="question-supplementary">
        <FirebaseKey className="text" firebaseKey={FirebaseService.faq_question_note}/>
        <span
          className="link"
          onClick={this.handleClickContactUs}
        >
          <FirebaseKey firebaseKey={FirebaseService.contact_us}/>
        </span>
      </div>
    );
  }

  private renderLink(): ReactNode {
    return (
      <div className="link-wrapper">
        <FirebaseKey className="text" firebaseKey={FirebaseService.faq_note}/>
        &nbsp;
        <span
          className="link"
          onClick={this.handleClickContactUs}
        >
          <FirebaseKey firebaseKey={FirebaseService.contact_us}/>
        </span>
      </div>
    );
  }

  private renderEmptyList(): ReactNode {
    return (
      <div className="link-wrapper empty-list">
        <FirebaseKey className="text" firebaseKey={FirebaseService.faq_no_result}/>
      </div>
    );
  }

  render() {
    return (
      <div id="faq-page" className="page">
        <div className="page-content">
          {this.renderSearch()}
          {this.renderQNAs()}
        </div>
      </div>
    );
  }
}

export default FaqPage;
